"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rule = exports.regex = exports.isRule = void 0;

var _tools = require("./tools");

/**
 * 正则
 */
var regex = {
  // 手机
  mobile: /^1\d{10}$/,
  // 邮箱
  email: /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/,
  // 钱
  money: /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/,
  // 用户
  name: /^([\u4e00-\u9fa5]+|[a-zA-Z0-9]+)$/,
  // 密码
  pwd: /(\d(?!\d{5})|[A-Za-z](?![A-Za-z]{5})){6}/,
  // 身份证
  idCardNo: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/
};
/**
 * 判断规则
 * @param {reg}    reg   正则
 * @param {string} value 值
 */

exports.regex = regex;

var isRule = function isRule(reg, value) {
  if (!value || value.length === 0) {
    return false;
  }

  if (!(reg instanceof RegExp)) {
    throw new Error('The rule shoud be RegExp');
  }

  if (!reg.test(value)) {
    return false;
  }

  return true;
};
/**
 * 验证
 */


exports.isRule = isRule;
var rule = {
  // 验证不为空
  isNotEmpty: function isNotEmpty(value) {
    return value && value.length > 0;
  },
  // 验证手机
  isMobile: function isMobile(value) {
    return isRule(regex.mobile, value);
  },
  // 验证邮箱
  isEmail: function isEmail(value) {
    return isRule(regex.email, value);
  },
  // 验证金钱
  isMoney: function isMoney(value) {
    return isRule(regex.money, value);
  },
  // 验证用户名
  isUsername: function isUsername(value, callback) {
    return isRule(regex.name, value);
  },
  // 验证用户名
  isPwd: function isPwd(value) {
    return isRule(regex.pwd, value);
  },
  // 验证身份证
  isIdCard: function isIdCard(value) {
    if (!value || value.length !== 18) {
      return false;
    }

    value = (0, _tools.toTrim)(value); // eslint-disable-next-line max-len

    var city = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    };
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    var birthday = "".concat(value.substr(6, 4), "/").concat(Number(value.substr(10, 2)), "/").concat(Number(value.substr(12, 2)));
    var d = new Date(birthday);
    var newBirthday = "".concat(d.getFullYear(), "/").concat(Number(d.getMonth() + 1), "/").concat(Number(d.getDate()));
    var time = d.getTime();
    var currentTime = new Date().getTime();

    if (!value || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(value)) {
      // return callback('证件号码格式错误');
      return false;
    } // 非法地区


    if (!city[value.substr(0, 2)]) {
      return false;
    }

    if (time >= currentTime || birthday !== newBirthday) {
      return false;
    }

    if (value.length === 18) {
      var sum = 0;

      for (var i = 0; i < 17; i += 1) {
        sum += value.substr(i, 1) * factor[i];
      } // 校验位错误
      // eslint-disable-next-line


      if (parity[sum % 11] != value.substr(17, 1)) {
        return false;
      }
    }

    return true; // callback();
  },
  // 获取身份证出生日期／性别
  getIdCard: function getIdCard(value) {
    if (!value) {
      return true;
    }

    var number = value.toUpperCase(); // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X

    if (!rule.isIdCard(number)) {
      return false;
    }

    var len = number.length;
    var birthday = '1990-01-01';
    var sex = 'M';

    if (len === 15) {
      // 获取出生日期
      birthday = "19".concat(value.substring(6, 8), "-").concat(value.substring(8, 10), "-").concat(value.substring(10, 12)); // 获取性别

      sex = +value.substr(14, 1) % 2 === 1 ? 'M' : 'F';
    } else {
      // 获取出生日期
      birthday = "".concat(value.substring(6, 10), "-").concat(value.substring(10, 12), "-").concat(value.substring(12, 14)); // 获取性别

      sex = +value.substr(16, 1) % 2 === 1 ? 'M' : 'F';
    }

    return {
      birthday: birthday,
      sex: sex
    };
  }
};
exports.rule = rule;